export default function scrollChatDown() {
  let container = document.getElementById("comments-container");
  if (container) {
    container.scrollTop = container.scrollHeight;
  }
}

window.addEventListener("resize", scrollChatDown);
